import React from 'react';
import { ArrowRight } from 'lucide-react';
import { portByCode, type Company } from '../../data/claudeMockData';

export function ProgressBar({ value }: { value: number }) {
  return (
    <div
      style={{
        width: '100%',
        height: 4,
        background: 'var(--surface-2)',
        borderRadius: 99,
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <div
        style={{
          width: `${Math.max(2, Math.min(100, value * 100))}%`,
          height: '100%',
          background: value >= 1 ? 'var(--st-success)' : 'var(--accent)',
          borderRadius: 99,
        }}
      />
    </div>
  );
}

export function RouteCell({ pol, pod }: { pol: string; pod: string }) {
  const a = portByCode(pol);
  const b = portByCode(pod);
  return (
    <div className="row gap-2" style={{ alignItems: 'center' }}>
      <span className="mono fw-500" style={{ fontSize: 11.5 }}>
        {a?.code || pol}
      </span>
      <ArrowRight size={12} strokeWidth={2} />
      <span className="mono fw-500" style={{ fontSize: 11.5 }}>
        {b?.code || pod}
      </span>
    </div>
  );
}

/**
 * Badge firmă (inițiale + culoare).
 *
 * Tooltip cu numele complet: **doar CSS** (`data-tooltip` + `::after`),
 * activ doar pe desktop (`hover: hover` + `pointer: fine`).
 * Fără React portals / Radix / event handlers pe fiecare rând — zero cost
 * de reredare pe liste lungi (problema de performanță pe care am mai avut-o).
 */
export function CompanyBadge({ company }: { company?: Company }) {
  if (!company) return null;
  const name = company.name || company.short || '';
  return (
    <span
      className="company-badge-wrap"
      data-tooltip={name}
      aria-label={name}
      // Fără `title` nativ: pe desktop ar da dublu (CSS + browser).
      // Pe touch tooltip-ul CSS e off (media query); aria-label acoperă a11y.
    >
      <span className="company-badge">
        <span className="swatch" style={{ background: company.color }} />
        <span className="company-badge-label">{company.short}</span>
      </span>
    </span>
  );
}
